// Fragmento « divers » (ES) : Sobre nosotros, Contacto, valoraciones de clientes,
// banner de cookies. Mismas claves que fr/divers.js, valores en español.
export default {
  // ---- Sobre nosotros (pages/About.jsx) ----
  'apropos.seo.titre': 'Sobre nosotros',
  'apropos.seo.description': 'Descubra la historia de Mirum Games y nuestra pasión por crear momentos mágicos en familia con Joyful Reveal, los puzles hechos con materiales de calidad.',
  'apropos.hero.badge': '🎮 Nuestra historia',
  'apropos.hero.titre': 'Bienvenido a Mirum Games',
  'apropos.hero.texte': 'Creamos momentos mágicos para celebrar la llegada de su bebé y compartir esa alegría en familia.',
  'apropos.mission.titre': 'Nuestra misión',
  'apropos.mission.texte1': 'En Mirum Games creemos que los momentos importantes de la vida merecen celebrarse de una forma única y memorable. Nuestra misión es crear experiencias festivas e interactivas que conviertan la revelación del sexo del bebé en un momento inolvidable para compartir en familia.',
  'apropos.mission.texte2': 'Cada puzle está diseñado con mimo para crear un momento de suspense y de alegría, con una calidad excepcional y una experiencia que toda la familia recordará.',
  'apropos.mission.encart.titre': 'Celebrar jugando',
  'apropos.mission.encart.texte': 'Convertir la revelación en un juego de preguntas y respuestas divertido en el que participa todo el mundo',
  'apropos.mission.carte1.titre': 'Suspense',
  'apropos.mission.carte1.texte': 'Crear un momento de suspense y de expectación memorable',
  'apropos.mission.carte2.titre': 'Fiesta',
  'apropos.mission.carte2.texte': 'Convertir la revelación en un acontecimiento festivo y memorable',
  'apropos.mission.carte3.titre': 'Compartir',
  'apropos.mission.carte3.texte': 'Momentos de calidad en familia',
  'apropos.valeurs.titre': 'Nuestros valores fundamentales',
  'apropos.valeurs.soustitre': 'Los principios que guían cada una de nuestras decisiones',
  'apropos.valeurs.excellence.titre': 'Excelencia',
  'apropos.valeurs.excellence.texte': 'Nunca hacemos concesiones con la calidad. Cada detalle cuenta, desde el diseño hasta el acabado del puzle.',
  'apropos.valeurs.creativite.titre': 'Creatividad',
  'apropos.valeurs.creativite.texte': 'Innovamos constantemente para crear revelaciones únicas y memorables que dejan huella.',
  'apropos.valeurs.authenticite.titre': 'Autenticidad',
  'apropos.valeurs.authenticite.texte': 'Seguimos siendo fieles a nuestros valores y a nuestro compromiso con nuestros clientes y con la comunidad.',
  'apropos.valeurs.innovation.titre': 'Innovación',
  'apropos.valeurs.innovation.texte': 'Exploramos sin parar nuevas formas de crear celebraciones excepcionales.',
  'apropos.valeurs.emotions.titre': 'Emociones',
  'apropos.valeurs.emotions.texte': 'Creamos momentos cargados de emoción que quedarán grabados en la memoria de toda la familia.',
  'apropos.valeurs.passion.titre': 'Pasión',
  'apropos.valeurs.passion.texte': 'Nos apasiona lo que hacemos, y eso se nota en cada producto.',
  'apropos.reseaux.titre': 'Nuestras redes sociales',
  'apropos.reseaux.soustitre': 'Únase a nuestra comunidad y descubra lo que pasa entre bastidores',
  'apropos.reseaux.instagram.texte': 'Descubra nuestras últimas creaciones, los entresijos de nuestros puzles y comparta sus momentos mágicos con #MirumGames',
  'apropos.reseaux.facebook.texte': 'Únase a nuestra comunidad, participe en los concursos y esté al día de nuestras ofertas exclusivas y novedades',
  'apropos.processus.titre': 'Nuestro proceso de creación',
  'apropos.processus.soustitre': 'De la idea a su casa',
  'apropos.processus.etape1.titre': 'Investigación e ideas',
  'apropos.processus.etape1.texte': 'Escuchamos a los futuros padres y a quienes organizan fiestas de gender reveal para crear experiencias cada vez más memorables.',
  'apropos.processus.etape2.titre': 'Diseño y pruebas',
  'apropos.processus.etape2.texte': 'Nuestro equipo diseña cada puzle y lo somete a pruebas rigurosas para garantizar una experiencia divertida y memorable.',
  'apropos.processus.etape3.titre': 'Fabricación',
  'apropos.processus.etape3.texte': 'Cada puzle se fabrica con mimo y atención al detalle para garantizar una calidad premium.',
  'apropos.processus.etape4.titre': 'Calidad y envío',
  'apropos.processus.etape4.texte': 'Cada juego pasa un estricto control de calidad antes de enviarse con cuidado a su casa.',
  'apropos.cta.titre': '¿Listo para descubrir nuestros juegos?',
  'apropos.cta.texte': 'Descubra nuestra colección completa y convierta la revelación del sexo de su bebé en un momento mágico e inolvidable.',
  'apropos.cta.boutique': '🛍️ Descubrir la tienda',
  'apropos.cta.contact': '💬 Contactar con nosotros',

  // ---- Contacto (pages/Contact.jsx) ----
  'contact.seo.titre': 'Contacto',
  'contact.seo.description': 'Ponte en contacto con Mirum Games para cualquier duda sobre Joyful Reveal, nuestro juego, o sobre tus pedidos. Respuesta rápida garantizada.',
  'contact.hero.badge': '💬 Sigamos en contacto',
  'contact.hero.titre': 'Nos encantaría saber de usted',
  'contact.hero.texte': '¿Tiene preguntas? ¿Sugerencias? No dude en escribirnos. Solemos responder en menos de 24 horas.',
  'contact.cartes.email.titre': 'Correo electrónico',
  'contact.cartes.email.texte': 'Respuesta en 24-48 h',
  'contact.cartes.adresse.titre': 'Dirección',
  'contact.cartes.adresse.ligne1': 'Rue de la Cortaille, 59',
  'contact.cartes.adresse.ligne2': '6800 Freux, Bélgica',
  'contact.cartes.faq.titre': '¿Preguntas?',
  'contact.cartes.faq.texte': 'Consulte nuestras FAQ',
  'contact.cartes.faq.soustexte': 'Respuestas al instante',
  'contact.formulaire.titre': 'Envíenos un mensaje',
  'contact.formulaire.nom': 'Su nombre',
  'contact.formulaire.nomPlaceholder': 'Juan Pérez',
  'contact.formulaire.email': 'Correo electrónico',
  'contact.formulaire.emailPlaceholder': 'su@email.com',
  'contact.formulaire.sujet': 'Asunto',
  'contact.formulaire.sujetPlaceholder': '-- Elija un asunto --',
  'contact.formulaire.sujetCommande': 'Pregunta sobre mi pedido',
  'contact.formulaire.sujetProduit': 'Pregunta sobre un producto',
  'contact.formulaire.sujetLivraison': 'Pregunta sobre el envío',
  'contact.formulaire.sujetPartenariat': 'Colaboración',
  'contact.formulaire.sujetAutre': 'Otro',
  'contact.formulaire.message': 'Mensaje',
  'contact.formulaire.messagePlaceholder': 'Su mensaje aquí...',
  'contact.formulaire.envoiEnCours': '⏳ Enviando...',
  'contact.formulaire.envoyer': '📬 Enviar el mensaje',
  'contact.formulaire.succes': '✨ ¡Gracias por su mensaje! Le responderemos muy pronto.',
  'contact.faq.titre': 'Preguntas frecuentes',
  'contact.faq.soustitre': 'Puede que su respuesta ya esté aquí',
  'contact.faq.q1': '❓ ¿Cuánto tarda el envío?',
  'contact.faq.a1': "Los pedidos salen de Bélgica en un día hábil de media. Después, cuenta con 1 a 2 días hábiles para Luxemburgo, Bélgica y los Países Bajos, 2 a 4 días para Francia y Alemania, y 4 a 5 días para España.",
  'contact.faq.q2': '🎁 ¿Puedo añadir un mensaje personalizado?',
  'contact.faq.a2': '¡Por supuesto! Nuestros packs premium incluyen una tarjeta personalizada. Escríbanos después de su pedido para ver los detalles.',
  'contact.faq.q3': '💰 ¿Tienen garantía?',
  'contact.faq.a3': '¡Sí! Dispone de 14 días para devolver un producto que no le convenza. Además, garantizamos todos nuestros productos contra defectos ocultos.',
  'contact.faq.q4': '🌍 ¿Envían al extranjero?',
  'contact.faq.a4': "Enviamos a Bélgica, Francia, Luxemburgo, los Países Bajos, Alemania y España. Al hacer el pedido eliges entre la entrega a domicilio y un punto de recogida, según los transportistas disponibles en tu dirección.",
  'contact.faq.q5': '🎮 ¿Cómo funciona el puzle?',
  'contact.faq.a5': 'Es un divertido juego de preguntas y respuestas que va guiando el montaje del puzle. ¡Cuando acierta, coloca las piezas y descubre el sexo del bebé!',
  'contact.faq.q6': '🎊 ¿Cuántas personas pueden jugar?',
  'contact.faq.a6': '¡El puzle está pensado para compartirlo en familia! Puede formar equipos y jugar entre varios para que el momento sea aún más festivo.',
  'contact.newsletter.titre': 'Manténgase informado',
  'contact.newsletter.texte': 'Suscríbase a nuestra newsletter para recibir las últimas ofertas y novedades',
  'contact.newsletter.emailPlaceholder': 'su@email.com',
  'contact.newsletter.inscrire': 'Suscribirse',
  'contact.newsletter.succes': '✨ ¡Bienvenido a nuestra newsletter!',

  // ---- Valoraciones de clientes (components/Reviews/*) ----
  // El CONTENIDO de las valoraciones (texto, título, nombre del autor) viene de
  // la base de datos y nunca se traduce ; solo el envoltorio usa estas claves.
  'avis.section.badge': '💬 Experiencias de clientes',
  'avis.section.titre': 'Lo que más gusta a nuestros clientes',
  'avis.section.accrocheAucun': '¿Ya ha jugado? Cuéntenos su momento — su valoración ayudará a decidirse a los próximos futuros padres.',
  'avis.section.accrochePeu': 'Jugaron antes que usted y se tomaron el tiempo de escribirnos. Estas son sus palabras, sin filtro.',
  'avis.section.accrocheNombreux': 'Ya son {n} familias las que han compartido su momento con nosotros.',
  'avis.section.compteurSingulier': 'valoración',
  'avis.section.compteurPluriel': 'valoraciones',
  'avis.section.premierAvis': '¡Sea el primero en dejar su valoración!',
  'avis.section.fermer': '✕ Cerrar',
  'avis.section.laisserAvis': '✍️ Dejar una valoración',
  'avis.section.chargement': 'Cargando las valoraciones...',
  'avis.section.listeTitre': 'Las valoraciones',
  'avis.section.aucunTitre': '¡Sea el primero!',
  'avis.section.aucunTexte': 'Todavía no hay valoraciones. ¡Sea el primero en compartir su experiencia mágica!',
  'avis.section.ecrirePremier': 'Escribir la primera valoración',
  'avis.section.erreurEnvoi': 'Error al enviar la valoración',
  'avis.carte.noteAria': 'Puntuación de {note} sobre 5',
  'avis.carte.clientVerifie': 'Cliente verificado',
  'avis.carte.achatVerifie': '✅ Compra verificada',
  'avis.formulaire.titre': 'Comparta su experiencia',
  'avis.formulaire.note': 'Puntuación global',
  'avis.formulaire.noterAria': 'Puntuar con {n} estrellas',
  'avis.formulaire.note5': '¡Excelente! 🤩',
  'avis.formulaire.note4': 'Muy bien 🙂',
  'avis.formulaire.note3': 'Bien 😐',
  'avis.formulaire.note2': 'Regular 😕',
  'avis.formulaire.note1': 'Decepcionado 😞',
  'avis.formulaire.titreAvis': 'Título de su valoración',
  'avis.formulaire.titrePlaceholder': 'Ej.: ¡Puzle genial, a mi hija le encanta!',
  'avis.formulaire.commentaire': 'Su comentario',
  'avis.formulaire.commentairePlaceholder': 'Cuéntenos qué le ha gustado...',
  'avis.formulaire.envoiEnCours': 'Enviando...',
  'avis.formulaire.publier': 'Publicar mi valoración',

  // ---- Banner de cookies (components/CookieConsent.jsx) ----
  'cookies.bandeau.titre': '🍪 Gestión de las cookies',
  'cookies.bandeau.texte': "Este sitio solo usa dos cosas: las cookies que necesitan tu cesta y tu inicio de sesión, y una medición de audiencia anónima, hecha por nosotros, sin cookie y sin identificarte nunca. Sin publicidad, sin perfilado, sin compartir nada con terceros.",
  'cookies.gerer': "Gestionar mis cookies",
  'cookies.categories.necessaires': 'Cookies necesarias',
  'cookies.categories.necessairesDesc': 'Siempre activas - Esenciales para el funcionamiento del sitio',
  'cookies.categories.analytics': "Medición de audiencia anónima",
  'cookies.categories.analyticsDesc': "Número de visitas y páginas consultadas. Sin cookie, sin identificador, tu dirección IP nunca se conserva. Puedes rechazarla.",
  'cookies.categories.marketing': 'Cookies de marketing',
  'cookies.categories.marketingDesc': 'Para ofrecerle contenido y ofertas personalizadas',
  'cookies.bandeau.voirNotre': 'Consulte nuestra',
  'cookies.bandeau.politique': 'Política de Privacidad',
  'cookies.bandeau.plusInfos': 'para más información',
  'cookies.actions.refuser': 'Rechazar todo',
  'cookies.actions.personnaliser': 'Personalizar',
  'cookies.actions.accepter': 'Aceptar todo',

  // --- Connexion, inscription, profil ---
  // Ces trois pages n'etaient pas traduites du tout : un visiteur allemand
  // cliquait « Anmelden » dans une barre de navigation allemande et recevait
  // un formulaire entierement francais.
  'compte.connexion.seoTitre': "Iniciar sesión",
  'compte.connexion.seoDescription': "Inicia sesión en tu cuenta de Mirum Games.",
  'compte.connexion.titre': "Iniciar sesión",
  'compte.connexion.sousTitre': "Bienvenida a Mirum Games",
  'compte.champ.email': "Correo electrónico",
  'compte.champ.emailPlaceholder': "tu@email.com",
  'compte.champ.motDePasse': "Contraseña",
  'compte.champ.motDePassePlaceholder': "Tu contraseña",
  'compte.champ.basculerMotDePasse': "Mostrar u ocultar la contraseña",
  'compte.connexion.seSouvenir': "Recordarme",
  'compte.connexion.motDePasseOublie': "🔑 ¿Has olvidado tu contraseña?",
  'compte.connexion.bouton': "🔓 Iniciar sesión",
  'compte.connexion.enCours': "⏳ Iniciando sesión…",
  'compte.connexion.ouContinuerAvec': "O continúa con",
  'compte.connexion.pasDeCompte': "¿Aún no tienes cuenta?",
  'compte.connexion.creerUnCompte': "Crear una cuenta",
  'compte.connexion.erreur': "Credenciales no válidas. Inténtalo de nuevo.",
  'compte.connexion.erreurGoogle': "Se ha producido un error al iniciar sesión con Google.",
  'compte.inscription.seoTitre': "Registro",
  'compte.inscription.seoDescription': "Crea tu cuenta de Mirum Games.",
  'compte.inscription.titre': "Registro",
  'compte.inscription.sousTitre': "Únete a la comunidad Mirum Games",
  'compte.champ.nomComplet': "Nombre completo",
  'compte.champ.nomCompletPlaceholder': "Ana García",
  'compte.champ.creerMotDePasse': "Crea una contraseña segura",
  'compte.champ.confirmation': "Confirmar contraseña",
  'compte.champ.confirmationPlaceholder': "Confirma tu contraseña",
  'compte.force.faible': "❌ Débil",
  'compte.force.moyen': "⚠️ Media",
  'compte.force.fort': "✅ Fuerte",
  'compte.inscription.accepteLes': "Acepto las",
  'compte.inscription.conditions': "condiciones generales de venta",
  'compte.inscription.etLa': "y la",
  'compte.inscription.politique': "política de privacidad",
  'compte.inscription.bouton': "🎮 Crear una cuenta",
  'compte.inscription.enCours': "⏳ Creando la cuenta…",
  'compte.inscription.dejaUnCompte': "¿Ya tienes una cuenta?",
  'compte.inscription.seConnecter': "Iniciar sesión",
  'compte.inscription.erreurMotsDePasse': "Las contraseñas no coinciden.",
  'compte.inscription.erreurConditions': "Acepta las condiciones de uso, por favor.",
  'compte.inscription.erreurLongueur': "La contraseña debe tener al menos 6 caracteres.",
  'compte.inscription.erreur': "Se ha producido un error al registrarte. Inténtalo de nuevo.",
  'compte.profil.deconnexion': "Cerrar sesión",
  'compte.profil.mesCommandes': "📦 Mis pedidos",
  'compte.profil.informations': "👤 Datos",
  'compte.profil.informationsTitre': "Datos personales",
  'compte.commandes.chargement': "Cargando tus pedidos…",
  'compte.commandes.aucune': "Todavía no has realizado ningún pedido.",
  'compte.commandes.decouvrir': "Descubre nuestros productos",
  'compte.commandes.articles': "Artículos:",
  'compte.commandes.total': "Total:",
  'compte.commandes.suiviLabel': "N.º de seguimiento:",
  'compte.commandes.suivre': "Seguir mi paquete",
  'compte.commandes.facture': "Descargar la factura",
  "compte.commandes.noteCredit": "Nota de crédito",
  'compte.commandes.avis': "Dejar una valoración",
  'compte.commandes.nonAuthentifie': "Tu sesión ha caducado. Vuelve a iniciar sesión.",
  'compte.commandes.erreur': "Se ha producido un error al cargar tus pedidos",
  'compte.statut.paid': "Pagado",
  'compte.statut.shipped': "Enviado",
  'compte.statut.delivered': "Entregado",
  'compte.statut.cancelled': "Cancelado",
  'compte.infos.general': "Datos generales",
  'compte.infos.nomComplet': "Nombre completo *",
  'compte.infos.emailFige': "El correo electrónico no se puede modificar",
  'compte.infos.adresseLivraison': "Dirección de entrega",
  'compte.infos.adresse': "Dirección",
  'compte.infos.adressePlaceholder': "Número y nombre de la calle",
  'compte.infos.ville': "Ciudad",
  'compte.infos.codePostal': "Código postal",
  'compte.infos.pays': "País",
  'compte.infos.choisirPays': "Elige un país",
  'compte.infos.telephone': "Teléfono",
  'compte.infos.enregistrer': "💾 Guardar",
  'compte.infos.enregistrement': "⏳ Guardando…",
  'compte.infos.succes': "✅ Tu perfil se ha actualizado.",
  'compte.infos.erreur': "❌ Se ha producido un error al actualizar tu perfil",
  "maFacture.seoTitre": "Recuperar mi factura - Mirum Games",
  "maFacture.seoDescription": "Recupere la factura de su pedido de Mirum Games con su número de pedido y su correo electrónico.",
  "maFacture.titre": "Recuperar mi factura",
  "maFacture.intro": "¿Compró sin cuenta y ya no encuentra el correo de confirmación? Indique su número de pedido y el correo electrónico que utilizó en la compra.",
  "maFacture.champNumero": "Número de pedido o de factura",
  "maFacture.champNumeroAide": "Figura en el correo de confirmación y en la página que apareció tras el pago.",
  "maFacture.champEmail": "Correo electrónico utilizado en la compra",
  "maFacture.bouton": "Recuperar mi factura",
  "maFacture.recherche": "Buscando…",
  "maFacture.introuvable": "No encontramos ningún pedido con estos datos. Compruebe el número y el correo electrónico utilizado en la compra.",
  "maFacture.tropDEssais": "Demasiados intentos seguidos. Espere un minuto y vuelva a intentarlo.",
  "maFacture.erreur": "La búsqueda no ha funcionado. Vuelva a intentarlo en un momento o escríbanos.",
  "maFacture.facture": "Su factura n.º {numero} está lista.",
  "maFacture.voirFacture": "🧾 Ver e imprimir la factura",
  "maFacture.langueDocument": "La factura está redactada en francés. Puede imprimirla o guardarla en PDF desde su navegador.",
  "maFacture.factureStripe": "🧾 Ver la factura de este pedido",
  "maFacture.enAttente": "Su pago todavía no ha llegado: le enviaremos la factura por correo electrónico en cuanto se reciba.",
  "maFacture.aucune": "Este pedido no tiene factura en línea. Escríbanos y se la enviaremos.",
  "maFacture.voirNote": "Nota de crédito n.º {numero}",
  "maFacture.compte": "¿Tiene una cuenta? Todas sus facturas están en",
};
